var React = require('react');

function TriangleBottomMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M65.8895 63.9426L101.867 10.2798L129.535 107.345L65.8895 63.9426Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M4.05533 56.9031L101.975 10.2912L66.017 63.8698L4.05533 56.9031Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M4.05859 56.9062L65.9766 63.868L129.541 107.348L4.05859 56.9062Z","fill":"#5915C7","key":2})]);
}

TriangleBottomMobile.defaultProps = {"width":"140","height":"108","viewBox":"0 0 140 108","fill":"none"};

module.exports = TriangleBottomMobile;

TriangleBottomMobile.default = TriangleBottomMobile;
